import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core';
import {
    fetchCart,
    updateCart,
    discardReservation,
    selectCart,
} from '%evp_ticket_frontend/js/redux/currentCart';
import selectCurrentOrder from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import { selectSeatsEnabled } from '%evp_ticket_frontend/js/redux/currentEvent';
import Cart from './component/Cart';

const styles = ({ spacing, palette }) => ({
    paper: {
        padding: spacing(1, 2),
        marginBottom: `${spacing(2)}px`,
    },
    price: {
        fontWeight: 'bold',
    },
    divider: {
        margin: spacing(2, 0),
    },
    icon: {
        backgroundColor: palette.background.paper,
    },
    total: {
        textAlign: 'right',
    },
});

export default compose(
    connect(
        state => ({
            cart: selectCart(state),
            order: selectCurrentOrder(state),
            seatsEnabled: selectSeatsEnabled(state),
        }),
        dispatch => ({
            fetchCart: payload => dispatch(fetchCart(payload)),
            updateCart: payload => dispatch(updateCart(payload)),
            discardReservation: payload => dispatch(discardReservation(payload)),
        }),
    ),
    withStyles(styles),
)(Cart);
